import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonApiService } from '../../common-api.service';
import { CommonDropdownService } from '../../common-dropdown.service';
import { MatSelect } from '@angular/material/select';
import { tap, filter, finalize } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { SnackbarService } from '../../snackbar.service';

@Component({
    selector: 'app-employee-login',
    templateUrl: './employee-login.component.html',
    styleUrls: ['./employee-login.component.css']
})
export class EmployeeLoginComponent implements OnInit {

    @ViewChild('employee_select', { static: false }) employee_select: MatSelect;
    @ViewChild('barcodeInput', { static: false }) barcodeInput: any;

    constructor(
        private router: Router,
        private api: CommonApiService,
        private route: ActivatedRoute,
        private dropdownService: CommonDropdownService,
        private snackbar: SnackbarService,
    ) {}

    passwordLength: any;
    public allEmployees: any[] = [];
    public selectedEmployee: number;
    public selectedEmployeeObject: any[] = [];
    public navigateTo: string = 'jobschedule';
    public type: string;
    public barcodeValue: string = '';
    public scanningInProgress: boolean = false;

    employeeSearchPage = 0;
    allEmployeesCount = 0;

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.type = params.type;
            if (this.type == 'in') {
                this.navigateTo = 'prodjobin';
            } else if (this.type == 'out') {
                this.navigateTo = 'prodjobout';
            }
        });

        this.onLoadEmployeeList();
    }

    onLoadEmployeeList() {
        const params = {
            pageIndex: this.employeeSearchPage,
            pageSize: environment.defaultPageSizeOnScroll
        };

        this.api.postAll('employee/list/display', params).pipe(
            tap((res: any) => {
                this.allEmployees.push(...res.items);
                this.allEmployeesCount = res.rowCount;
            }),
            filter(() => this.selectedEmployeeObject.length !== 0),
            tap(() => {
                const selectedId = this.selectedEmployeeObject[0].id;
                this.allEmployees = this.allEmployees.filter(e => e.id !== selectedId);
                this.allEmployees.unshift(this.selectedEmployeeObject[0]);
            }),
            finalize(() => this.employeeSearchPage++)
        ).subscribe();
    }

    onEmployeeKey(event: Event) {
        const value = (event.target as HTMLInputElement).value;
        this.dropdownService.updateSearchResults(value, 'employee', this.allEmployees, this.selectedEmployeeObject, 'employeeSearchPage')
            .subscribe((result: { entityList: any[], pageVariable: number }) => {
                this.allEmployees = result.entityList;
                this.employeeSearchPage = result.pageVariable;
            });
    }

    onEmployeeScroll(event: any) {
        if (!this.employee_select?.panel || !this.employee_select?.panel.nativeElement) {
            return;
        }
        if (event) {
            this.employee_select.panel.nativeElement.addEventListener(
                'scroll',
                (ev: any) => {
                    const tolerance = 10;
                    if (
                        Math.floor(this.employee_select.panel.nativeElement.scrollTop) + tolerance >=
                        Math.floor(this.employee_select.panel.nativeElement.scrollHeight) -
                        Math.floor(this.employee_select.panel.nativeElement.offsetHeight)
                    ) {
                        if (this.allEmployees.length >= this.allEmployeesCount) {
                            return;
                        }
                        const params = {
                            pageIndex: this.employeeSearchPage,
                            pageSize: environment.defaultPageSizeOnScroll
                        };
                        this.api.postAll('employee/list/display', params).subscribe((res: any) => {
                            res.items = res.items.filter((entity: any) => entity.id !== this.selectedEmployeeObject[0]?.id);
                            this.allEmployees.push(...res.items);
                        });
                        this.employeeSearchPage++;
                    }
                }
            );
        }
    }

    keyPress(event: any) {
        this.passwordLength = event.target.value.length;
        if (this.passwordLength == 3) {
            const pin = event.target.value + event.key;
            if (!this.selectedEmployee) {
                this.snackbar.warning('Please select an employee first');
                return;
            }
            this.api.postAll('employee/validate-pin', {
                employee_id: this.selectedEmployee,
                pin: pin
            }).subscribe({
                next: (res: any) => {
                    if (res && res.id) {
                        this.snackbar.success(`Welcome, ${res.name}`);
                        localStorage.setItem('employee_id', String(res.id));
                        this.router.navigate([this.navigateTo]);
                    }
                },
                error: (err: any) => {
                    this.snackbar.error(err?.error?.message || 'Invalid security key');
                    event.target.value = '';
                }
            });
        }
    }

    onBarcodeScan(event: KeyboardEvent) {
        if (event.key !== 'Enter') {
            return;
        }
        event.preventDefault();
        const scannedValue = this.barcodeValue.trim();
        if (!scannedValue) {
            return;
        }

        this.scanningInProgress = true;
        this.api.postAll('employee/lookup/barcode', { barcode_value: scannedValue }).subscribe({
            next: (res: any) => {
                this.scanningInProgress = false;
                if (res && res.id) {
                    this.snackbar.success(`Welcome, ${res.name}`);
                    localStorage.setItem('employee_id', String(res.id));
                    this.router.navigate([this.navigateTo]);
                } else {
                    this.snackbar.error('Employee not found');
                    this.barcodeValue = '';
                }
            },
            error: (err: any) => {
                this.scanningInProgress = false;
                this.snackbar.error(err?.error?.message || 'Employee not found');
                this.barcodeValue = '';
            }
        });
    }

}
